<template>
<div>
  <div class="user-group-selection-container">
    <p v-if="selectedGroupsCount > 0">
      {{ $tc('marker.selected_user_groups_count',
         selectedGroupsCount >= 2 ? 2 : 1, {
         count: selectedGroupsCount
       }) }}
      <span>
        <a href="#" @click.stop.prevent="toggleShowSelection">{{ $t('marker.user_group_click_here') }}</a>
        {{ $t('marker.user_group_to_change_selection') }}
      </span>
    </p>
    <p v-else>
      {{ $t('marker.all_users_will_be_notified') }}
      <span>
        {{ $t('marker.user_group_you_may') }}
        <a href="#" @click.stop.prevent="toggleShowSelection">{{ $t('marker.user_group_specify') }}</a>
        {{ $t('marker.user_group_which_groups_to_target') }}
      </span>
    </p>
    <div v-if="showSelection" class="user-group-selection" :style="{top: tooltipPosition.y + 'px', left: tooltipPosition.x + 'px'}">
      <div class="user-group-selection-header">
        <div>
          {{ $t('marker.user_group_categories') }}
        </div>
        <div>
          {{ $t('marker.user_groups') }}
        </div>
      </div>
      <div class="user-group-selection-content">
        <ul class="user-group-category">
          <li v-for="category in groups" @click.stop="showCategory = category.slug" :class="{'selected': shownCategory === category.slug}">
            {{ category.name }} <span class="glyphicon glyphicon-chevron-right"></span>
          </li>
        </ul>
        <ul class="user-group">
          <template v-for="category in groups">
          <li
              v-for="group in category.groups"
              v-show="category.slug === shownCategory"
              :class="{'selected': isSelected(category, group)}"
              @click.stop="toggle(category, group)">
            {{ group.name }}
            <span class="glyphicon glyphicon-ok-circle"></span>
          </li>
          </template>
        </ul>
      </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['groups', 'value'],
  data () {
    return {
      showSelection: false,
      showCategory: null,
      tooltipPosition: {
        x: 0, y: 0
      }
    }
  },
  mounted () {
    document.body.addEventListener('click', this.hide)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.hide)
  },
  methods: {
    hide () {
      this.showSelection = false
    },
    isSelected (category, group) {
      return this.value && this.value.find((cat) => {
        return category.slug === cat.slug && cat.groups.find((g) => {
          return g.slug === group.slug
        })
      })
    },
    toggleShowSelection (event) {
      this.tooltipPosition = {x: event.layerX, y: event.layerY}
      this.showSelection = !this.showSelection
    },
    toggle (clickedCategory, clickedGroup) {
      // merge the selected group with the current value and emit the result
      const newValue = []
      let removed = false
      // create a new value, and remove the clicked group if it is found in the old value
      for (let cat of this.value) {
        newValue.push({
          name: cat.name,
          slug: cat.slug,
          groups: cat.groups.reduce((result, grp) => {
            if (cat.slug !== clickedCategory.slug || grp.slug !== clickedGroup.slug) {
              result.push(grp)
            } else {
              removed = true
            }
            return result
          }, [])
        })
      }
      // the clicked group wasn't found in the existing value, so we add it to the result
      if (!removed) {
        for (let cat of this.groups) {
          if (cat.slug === clickedCategory.slug) {
            let newCat = newValue.find((c) => {
              return c.slug === clickedCategory.slug
            })
            if (!newCat) {
              newCat = {
                name: cat.name,
                slug: cat.slug,
                groups: []
              }
              newValue.push(newCat)
            }
            newCat.groups.push(clickedGroup)
          }
        }
      }
      this.$emit('input', newValue)
    }
  },
  computed: {
    shownCategory () {
      return this.showCategory ? this.showCategory : this.groups[0].slug
    },
    selectedGroupsCount () {
      if (!this.value) {
        return 0
      }
      return this.value.reduce((total, cat) => {
        total += cat.groups.length
        return total
      }, 0)
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// SelectGroups.vue?ebe0eb2a